import { email, propertyMapping, required } from '@hakla/typed-forms'
import { CreateAccount } from '@/api/generated'

export interface CreateAccountForm {
  email: string
  name: string
}

export function createAccountFormMapping() {
  return propertyMapping<CreateAccount, CreateAccountForm>(({ generic }) => {
    return {
      email: generic('email').validations(email, required),
      name: generic('name').validations(required),
    }
  })
}
